// extracted by mini-css-extract-plugin
export default {"filter":"EditQuestion_filter__6HJDl","fadeIn":"EditQuestion_fadeIn__8YmmR","tblheader":"EditQuestion_tblheader__uNx2d","btn":"EditQuestion_btn__RKEPH"};